// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDBEofeu_t1aEaDxWpoYWd2tCIltCWOnno",
  authDomain: "computerplustech.firebaseapp.com",
  projectId: "computerplustech",
  storageBucket: "computerplustech.appspot.com",
  messagingSenderId: "895402523025",
  appId: "1:895402523025:web:c23b08a2edf82232550230",
  measurementId: "G-6XTZPQ0JLH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


export default app ;

